import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';
import { DEBT_OBLIGATIONS_SELECT_OPTIONS } from '../../../../../../../constants';

class ListObligationsOrUploadDebtScheduleAnswerIs implements Rule {
  private answer:
    | DEBT_OBLIGATIONS_SELECT_OPTIONS.DEBT_SCHEDULE
    | DEBT_OBLIGATIONS_SELECT_OPTIONS.LIST_OUT_DEBT_OBLIGATIONS;

  public setAnswer(
    response:
      | DEBT_OBLIGATIONS_SELECT_OPTIONS.DEBT_SCHEDULE
      | DEBT_OBLIGATIONS_SELECT_OPTIONS.LIST_OUT_DEBT_OBLIGATIONS
  ) {
    this.answer = response;
    return this;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const isSameAnswer =
      application.upload_or_list_debt_obligations == this.answer;

    return isSameAnswer ?? false;
  }
}

export default new ListObligationsOrUploadDebtScheduleAnswerIs();
